import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';

const Footer = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo and Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src={require('../assets/images/new_logo.svg').default}
                alt="MagoMeal Logo"
                style={{ height: '180px', width: 'auto', marginBottom: '24px' }}
              />
              <p className="body-medium">
                {language === 'nl'
                  ? 'Leider in de duurzame verpakkingsrevolutie met innovatieve eetbare oplossingen.'
                  : 'Leading the sustainable packaging revolution with innovative edible solutions.'}
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="heading-3">{language === 'nl' ? 'Snelle Links' : 'Quick Links'}</h4>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">{t('nav.home')}</Link>
              <Link to="/about" className="footer-link">{t('nav.about')}</Link>
              <Link to="/edible-cups" className="footer-link">{t('nav.edibleCup')}</Link>
              <Link to="/cutlery-tableware" className="footer-link">{t('nav.cutleryTableware')}</Link>
              <Link to="/certifications" className="footer-link">{t('nav.certifications')}</Link>
              <Link to="/blog" className="footer-link">{t('nav.blog')}</Link>
              <Link to="/contact" className="footer-link">{t('nav.contact')}</Link>
              <Link to="/shop" className="footer-link">{t('nav.shop')}</Link>
            </nav>
          </div>

          {/* ✅ Legal Section */}
          <div className="footer-section">
            <h4 className="heading-3">{language === 'nl' ? 'Diensten' : 'Services'}</h4>
            <nav className="footer-nav">
              <Link to="/privacy-policy" className="footer-link">{t('footer.privacyPolicy')}</Link>
              <Link to="/terms-conditions" className="footer-link">{t('footer.termsConditions')}</Link>
              <Link to="/cookie-policy" className="footer-link">{t('footer.cookiePolicy')}</Link>
              <Link to="/delivery-return" className="footer-link">{t('footer.deliveryReturn')}</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="heading-3">{language === 'nl' ? 'Neem Contact Op' : 'Get In Touch'}</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={20} />
                <span>info@magomeal.nl</span>
              </div>
              <div className="contact-item">
                <Phone size={20} />
                <span>+31 628 25 32 18</span>
              </div>
            </div>

            {/* Newsletter Signup */}
            <div className="newsletter-signup">
              <h5 className="body-large">{language === 'nl' ? 'Blijf Op De Hoogte' : 'Stay Updated'}</h5>
              <form className="newsletter-form">
                <input
                  type="email"
                  placeholder={t('footer.enterEmail')}
                  className="newsletter-input"
                />
                <button type="submit" className="btn-primary">{t('footer.subscribeBtn')}</button>
              </form>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="body-small">
              © {new Date().getFullYear()} MagoMeal. {t('footer.allRightsReserved')}. {language === 'nl' ? 'Leveren van innovatieve eetbare producten aan de Benelux.' : 'Delivering innovative edible products to the Benelux.'}
            </p>
            <p className="body-small">
              Web development by Magomeal v2.4
            </p>
            <p className="body-small">
              {language === 'nl' ? 'Laatste Update Apri 2026.' : 'Last Update May 2026.'}
            </p>
          </div>
          <div className="footer-bottom-content">
            <p className="body-small">
              {language === 'nl' ? 'KvK nummer: 98332538' : 'Chamber of Commerce number: 98332538'}
            </p>
          </div>
          <div className="footer-bottom-content">
            <p className="body-small">
              VAT: NL005324390B18
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;